import headlineAnalysisTpl from '../templates/headline_analysis.directive.html';

function HeadlineAnalysisController(HeadlineService) {
  var vm = this;

  vm.service = HeadlineService;

  return vm;
}

HeadlineAnalysisController.$inject = ['HeadlineService'];

export default function headlineAnalysis() {
  return {
    template: headlineAnalysisTpl,
    controller: HeadlineAnalysisController,
    controllerAs: 'vm',
    bindToController: true,
    scope: {
      screenSize: '='
    }
  };
}
